<template>
<div>
    <header id="header-out">
        <h1>Waple</h1>
    </header>
    <section id="wrap">
        <div class="customer-page">
            <div class="complete">
                고객 인증 및 정보 등록을<br/>완료하였습니다.
            </div>
        </div>
    </section>
</div>
</template>

<script>

export default {
  data(){
  },
    methods: {
    },
    mounted() {
    },
};
</script>
